/** @format */
import React from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { lettersOnly } from '../../Config/Regex';
import { cardServices } from '../../Services/card.services';

const AddCardType = ({ onSuccess, setResultModal, disabled }) => {
	const { t: translator } = useTranslation();
	const { register, handleSubmit, errors } = useForm({
		mode: 'onChange',
		reValidateMode: 'onChange',
	});

	const onSubmit = data => {
		cardServices
			.createCard(data.name)
			.then(res => {
				onSuccess();
				setResultModal({
					show: true,
					title: translator('CardTypes-AddCardType-SuccesModal-Title'),
					text: translator(res.data.message),
					btnClass: 'btn btn-primary',
				});
			})
			.catch(err => console.log(err));
	};
	return (
		<form
			onSubmit={handleSubmit(onSubmit)}
			className='p-4'
			style={{ border: '1px solid lightgray' }}>
			<h5 className='mb-4 text-center font-weight-bold'>
				{translator('CardTypes-AddNew')}
			</h5>

			<fieldset className='scheduler-border'>
				<div className='form-group'>
					<label>{translator('Administration-CardTypes-CardName')}</label>
					<input
						type='text'
						className='form-control'
						ref={register({
							required: true,
							pattern: lettersOnly,
							maxLength: 20,
						})}
						name='name'
						disabled={disabled}
					/>
					{errors.name && errors.name.type === 'required' && (
						<p className='text-danger'>{translator('ValidationMsg-RequiredField')}</p>
					)}
					{errors.name && errors.name.type === 'pattern' && (
						<p className='text-danger'>{translator('ValidationMsg-LettersOnly')}</p>
					)}
					{errors.name && errors.name.type === 'maxLength' && (
						<p className='text-danger'>{translator('ValidationMsg-MaxLength20')}</p>
					)}
				</div>
			</fieldset>

			<div className='d-flex justify-content-end mt-2'>
				<button className='btn btn-primary' type='submit' disabled={disabled}>
					{translator('Btn-Save')}
				</button>
			</div>
		</form>
		// </Modal>
	);
};

export default AddCardType;
